// @flow
import createReducer from 'store/createReducer';
import AppActions from 'actions/app.actions';
 
export const initialState = {
  init: false,
  content: null,
  customerType: '',
  customerTypeContentKey: '',
  msisdn: '',
  eid: '',
  toggles: null,
  togglesNew: null,
  isLoading: false,
  error: null,
};

export default createReducer(initialState, {
  [AppActions.INIT]: (draft) => {
    draft.init = true;
  },
  [AppActions.IS_LOADING]: (draft, action) => {
    draft.isLoading = action.payload;
  },
  [AppActions.HAS_ERROR]: (draft, action) => {
    draft.error = action.payload;
  },
  [AppActions.IS_CUSTOMER_TYPE]: (draft, payload) => {
    draft.customerType = payload.customerType;
    draft.customerTypeContentKey = payload.customerTypeContentKey;
  },
  [AppActions.SET_MSISDN]: (draft, payload) => {
    draft.msisdn = payload.msisdn;
  },
  [AppActions.SET_EID]: (draft, payload) => {
    draft.eid = payload.eid;
  },
  [AppActions.SET_TOGGLES]: (draft, payload) => {
    draft.toggles = payload.toggles;
    draft.togglesNew = payload.togglesNew;
  },
  [AppActions.FETCH_APP_CONTENT_COMPLETE]: (draft, payload) => {
    draft.content = payload.data;
  },
});
